/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_Sovereign_PrimaryInputs */

const en_domain_manager_sovereign_primary = /** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Primary`)
};

const es_domain_manager_sovereign_primary = /** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Principal`)
};

const fr_domain_manager_sovereign_primary = /** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Principal`)
};

const de_domain_manager_sovereign_primary = /** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Primär`)
};

/** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */
const ja_domain_manager_sovereign_primary = en_domain_manager_sovereign_primary;

/** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */
const zh_domain_manager_sovereign_primary = en_domain_manager_sovereign_primary;

/** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */
const ar_domain_manager_sovereign_primary = en_domain_manager_sovereign_primary;

/** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */
const id_domain_manager_sovereign_primary = en_domain_manager_sovereign_primary;

/** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */
const it_domain_manager_sovereign_primary = en_domain_manager_sovereign_primary;

/** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */
const ru_domain_manager_sovereign_primary = en_domain_manager_sovereign_primary;

/** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */
const pt_domain_manager_sovereign_primary = en_domain_manager_sovereign_primary;

/** @type {(inputs: Domain_Manager_Sovereign_PrimaryInputs) => LocalizedString} */
const ko_domain_manager_sovereign_primary = en_domain_manager_sovereign_primary;

/**
* | output |
* | --- |
* | "Sovereign Primary" |
*
* @param {Domain_Manager_Sovereign_PrimaryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_sovereign_primary = /** @type {((inputs?: Domain_Manager_Sovereign_PrimaryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Sovereign_PrimaryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_sovereign_primary(inputs)
	if (locale === "es") return es_domain_manager_sovereign_primary(inputs)
	if (locale === "fr") return fr_domain_manager_sovereign_primary(inputs)
	if (locale === "de") return de_domain_manager_sovereign_primary(inputs)
	if (locale === "ja") return ja_domain_manager_sovereign_primary(inputs)
	if (locale === "zh") return zh_domain_manager_sovereign_primary(inputs)
	if (locale === "ar") return ar_domain_manager_sovereign_primary(inputs)
	if (locale === "id") return id_domain_manager_sovereign_primary(inputs)
	if (locale === "it") return it_domain_manager_sovereign_primary(inputs)
	if (locale === "ru") return ru_domain_manager_sovereign_primary(inputs)
	if (locale === "pt") return pt_domain_manager_sovereign_primary(inputs)
	return ko_domain_manager_sovereign_primary(inputs)
});